export enum EFrequency {
  /** Получать мнгновенно **/
  Asap = 'asap',
  /** Получать каждый день **/
  Daily = 'daily',
  /** Получать каждый час **/
  Hourly = 'hourly',
}

export enum ESavedSearchFrequency {
  None = 'none',
  Asap = 'asap',
  Daily = 'daily',
  Hourly = 'hourly',
}

export interface ISavedSearch {
  id?: number;
  address?: string | null;
  description?: string | null;
  name?: string;
  status?: string;
  frequency?: string | null;
  selectedFrequency?: string | null;
  newOffersCount?: number | null;
  link?: string;
}

export interface ISavedSearches {
  isFetching: boolean;
  errorCode?: number;
  count: number | null;
  searches: ISavedSearch[] | null;
}

export interface ISavedSearchesNotificationState {
  visible: boolean;
}
